/**
 * @module Components.SignUp
 *
 * Right-panel content for the athlete signup branch (invited gate + invite
 * dead end). Rendered via SignUpWrapper's sideContent instead of the default
 * "Welcome to CoachNow" panel.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

export default function AthleteSidePanel() {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t("Your coach sets everything up")}</h2>
      <p className={styles.description}>
        {t(
          "No credit card needed. When you join through a coach invite, you get full access as long as your coach is a PRO subscriber.",
        )}
      </p>

      <div className={styles.card}>
        <span className={styles.card_icon} aria-hidden="true">
          ✉️
        </span>
        <span className={styles.card_title}>{t("Check your email")}</span>
        <span className={styles.card_description}>
          {t(
            "Your coach will send an invite link directly to your email address.",
          )}
        </span>
      </div>
    </div>
  );
}
